import * as aiChat from './aiChat';

export const selectors = {
  aiChat: aiChat.selectors,
};
